import { type FC } from "react";

import { Alert } from "@snapchat/snap-design-system";

import { LensSubmissionErrors } from "../../../../lenses/components/list/lens-submission-errors";
import { useSubmissionErrors } from "../../../hooks";

import { RejectionErrorsPanelV2ModalTriggerTextContainer } from "./RejectionErrorsPanelV2.styles";
import {
    RejectionErrorsPanelV2Message,
    RejectionErrorsPanelV2ModalTriggerText,
    SubmissionErrorsPanelV2Message,
} from "./messages.generated";

interface RejectionErrorsPanelV2Props {
    lensId: string;
    className?: string;
}

export const RejectionErrorsPanelV2: FC<RejectionErrorsPanelV2Props> = ({ lensId, className }) => {
    const {
        submissionErrors,
        hasSubmissionErrors,
        hasRejectionErrors,
        loading: errorsLoading,
    } = useSubmissionErrors(lensId);

    if (!hasSubmissionErrors) {
        return null;
    }

    const rejectionErrorsModalWithTrigger = (
        <LensSubmissionErrors submissionErrors={submissionErrors} errorsLoading={errorsLoading}>
            <RejectionErrorsPanelV2ModalTriggerTextContainer>
                <RejectionErrorsPanelV2ModalTriggerText />
            </RejectionErrorsPanelV2ModalTriggerTextContainer>
        </LensSubmissionErrors>
    );

    return (
        <Alert
            className={className}
            title={
                hasRejectionErrors ? (
                    <RejectionErrorsPanelV2Message rejectionErrorsModalWithTrigger={rejectionErrorsModalWithTrigger} />
                ) : (
                    <SubmissionErrorsPanelV2Message rejectionErrorsModalWithTrigger={rejectionErrorsModalWithTrigger} />
                )
            }
            status="error"
            data-testid="rejection-errors-panel-v2"
        />
    );
};
